import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ReviewsService {
  constructor(private httpClient: HttpClient) {}

  getReviews( reviewId,pagination={
    page:0,
    pageSize:10
  },filter:any={
    status:"null",
    productId:"null",
    customerName:null,
    UserId:null
   
  }) {
    return this.httpClient.post("/ReviewApi/grid", {
      Pagination: { Start: pagination.page, Number: pagination.pageSize },
      Search: {
        predicateObject: {
          Id:reviewId?reviewId:null,
          Status:
            filter.status == "null" || +filter.status == 0
              ? null
              : +filter.status,
          ProductId:
            filter.productId == "null" || +filter.productId == 0
              ? null
              : +filter.productId,
          Name:
            filter.customerName 
              ?  filter.customerName
              :null,
              UserId:filter.UserId?filter.UserId:null
        
          
         
        },

      },
      Sort: {},
    });
  }

  approve(review) {
    return this.httpClient.post("/reviews/change-status/" + review.id, 5);
  }
  details(entityId) {
    return this.httpClient.get(`/reviews/get-review-details/${entityId}`);
  }
  getBarber(data) {
    return this.httpClient.get(`/UserBooking/Get?bookingId=${data.entityId}`);
  }
  getAllComments(pagination={
    page:0,
    pageSize:10
  },filter={
    status:"null",
    productId:"null",
    customerName:null,
    UserId:null
  }) {
    // Comments are a separate entity from reviews with their own grid. This posted to
    // /ReviewApi/grid, which returns ReviewViewModel, so commenterName/commentText/
    // creationDate/type came back undefined and those four columns rendered blank -
    // and the ids fed to /CommentsApi/ChangeStatus were review ids, not comment ids.
    return this.httpClient.post("/CommentsApi/Grid", {
      Pagination: { Start: pagination.page, Number: pagination.pageSize },
      Search: {
        predicateObject: {
          
          Status:
            filter.status == "null" || +filter.status == 0
              ? null
              : +filter.status,
          ProductId:
            filter.productId == "null" || +filter.productId == 0
              ? null
              : +filter.productId,
          Name:
            filter.customerName 
              ?  filter.customerName
              :null,
          UserId:filter.UserId ?  filter.UserId : null
          
         
        },

      },
      Sort: {},
    });
  }
  getAllReviewsReplies(
    pagination={
      page:0,
      pageSize:10
    }
  ) {
    // The pagination argument used to be ignored while the body asked for
    // 10000 rows, so every call pulled the whole replies table.
    return this.httpClient.post("/review-replies/grid", {
      Pagination: { Start: pagination.page, Number: pagination.pageSize },
      Search: {},
      Sort: {},
    });
  }
  changeStatus(id,status){
    return this.httpClient.put(`/CommentsApi/ChangeStatus/${id}/${status}`,{});
  }

  changeStatusReview(id,status){
    return this.httpClient.post(`/ReviewApi/ChangeStatus/${id}/${status}`,{});
  }
  changeStatusReply(id,status){
    return this.httpClient.post(`/ReplyApi/ChangeStatus/${id}/${status}`,{});
  }
  getAllProducts(){
    return this.httpClient.get(`/ProductApi/GetProductsForAdmin`);
  }
  blockUser(id){
    return this.httpClient.put(`/ReviewApi/blockuser/${id}`,{});
  }
  getReplies(reviewId,pagination={
    page:0,
    pageSize:10
  },filter={
    status:"null",
    productId:"null",
    customerName:null,
   
  }){
    return this.httpClient.post("/ReplyApi/grid", {
      Pagination: { Start: pagination.page, Number: pagination.pageSize },
      Search: {
        predicateObject: {
          ReviewId:reviewId?reviewId:null,
          Status:
            filter.status == "null" || +filter.status == 0
              ? null
              : +filter.status,
          ProductId:
            filter.productId == "null" || +filter.productId == 0
              ? null
              : +filter.productId,
          Name:
            filter.customerName 
              ?  filter.customerName
              :null, 
        },

      },
      Sort: {},
    });

  }
  getAllBlockedUsers(pagination={
    page:0,
    pageSize:10
  },filter={
    
    customerName:null
  }){
    return this.httpClient.post("/ReviewApi/GetUserBlocked", {
      "username": filter.customerName,
      "pageSize": pagination.pageSize,
      "pageNumber":  pagination.page
    });
  }
  unBlockUser(id){
    return this.httpClient.put(`/ReviewApi/unblockuser/${id}`,{});
  }
}
